import React, { useMemo } from 'react';
import { Provider } from 'react-redux';

import configureStore from '../call_list/store/configure';
import CallConsoleHeader, { type CallConsoleHeaderProps } from './call_console_header';
import CallListItem from '../call_list/call_list_item';
import { Container } from 'react-bootstrap-5';
import { type InsightsProperty } from 'bundles/connect/types';

// TODO_GL: Move this into call_list_item once converted to TS
type CallListItemProps = {
  activities?: any[], // TODO_GL: properly type this
  callListId: number,
  callTemplates: any[], // TODO_GL: properly type this
  insightsProperty: InsightsProperty,
  recordId: number,
  recordType: string,
  rethinkInstanceUrl: string,
  trialUser: boolean,
}

type CallConsoleProps = CallConsoleHeaderProps & CallListItemProps

export default function CallConsole({
  activities,
  callConsoleData,
  callListLength,
  callTemplates,
  remainingCredits,
  rethinkInstanceUrl,
  trialUser
}: CallConsoleProps) {
  const store = useMemo(() => configureStore({
    activities,
    owners: null,
    insightsPropertyId: callConsoleData.insightsProperty.propertyId,
    rethinkPropertyId: callConsoleData.rethinkPropertyId,
    callConsoleData
  }), []);

  const HEADER_PROPS = {
    callConsoleData,
    callListLength,
    remainingCredits,
    trialUser,
    rethinkInstanceUrl,
  };

  const CALL_LIST_ITEM_PROPS = {
    callConsoleData,
    activities,
    callTemplates,
    rethinkInstanceUrl,
    trialUser,
  };

  return (
    <Provider store={store}>
      <div className="bg-white border-bottom py-4">
        <Container fluid>
          <CallConsoleHeader {...HEADER_PROPS} />
        </Container>
      </div>
      <div className="flex-grow-1 py-6 px-md-6">
        <CallListItem {...CALL_LIST_ITEM_PROPS} />
      </div>
    </Provider>
  );
}
